import fr from "./locales/fr.json";
import en from "./locales/en.json";

// To add a language: create locales/xx.json with the same keys and register it here.
export const LANGUAGES = {
  fr: { label: "Français", short: "FR", locale: "fr-FR", dict: fr },
  en: { label: "English", short: "EN", locale: "en-US", dict: en },
};
export const DEFAULT_LANG = "fr";
const KEY = "mmp_lang";
const isBot = () => /bot|crawl|spider|slurp|google|bing|yandex|duckduck|baidu|facebookexternalhit|lighthouse/i.test(navigator.userAgent);

function detect() {
  const param = new URLSearchParams(window.location.search).get("lang");
  if (LANGUAGES[param]) {
    localStorage.setItem(KEY, param);
    return param;
  }
  const saved = localStorage.getItem(KEY);
  if (LANGUAGES[saved]) return saved;
  if (isBot()) return DEFAULT_LANG;
  const nav = (navigator.languages || [navigator.language]).map((l) => (l || "").slice(0, 2).toLowerCase());
  return nav.find((l) => LANGUAGES[l]) || DEFAULT_LANG;
}

export const lang = detect();
export const locale = LANGUAGES[lang].locale;
document.documentElement.lang = lang;
const dict = LANGUAGES[lang].dict;

const globals = { cur: "€" };
export const setGlobal = (k, v) => { globals[k] = v; };

export function t(key, vars) {
  const s = dict[key] ?? fr[key] ?? key;
  return s.includes("{{") ? s.replace(/\{\{(\w+)\}\}/g, (_, k) => (vars?.[k] ?? globals[k] ?? "")) : s;
}

export function setLang(next) {
  if (!LANGUAGES[next] || next === lang) return;
  localStorage.setItem(KEY, next);
  const url = new URL(window.location.href);
  if (url.searchParams.has("lang")) url.searchParams.set("lang", next);
  window.location.replace(url.toString());
}
